import {
  useCallback 
} from "react"

export const useTrackOrder = (props) => {
  const {
    afterSubmit 
  } = props

  const handleSubmit = useCallback(
    async (formState) => {
      const {
        values 
      } = formState
      const {
        email, ordernumber 
      } = values

      if (afterSubmit) {
        afterSubmit(email, ordernumber)
      }
    },
    [afterSubmit]
  )

  return {
    handleSubmit,
  }
}
